"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inactivityLogoutDefaultValue = exports.inactivityLogoutSchema = void 0;
const zod_1 = require("zod");
exports.inactivityLogoutSchema = zod_1.z.object({
    expiresInMinutes: zod_1.z.number(),
    logoutWhenCloseBrowser: zod_1.z.boolean(),
});
const defaultValue = {
    expiresInMinutes: 10,
    logoutWhenCloseBrowser: true,
};
exports.inactivityLogoutDefaultValue = JSON.stringify(defaultValue, null, '\t');
